import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/live.png")